import { Link } from "react-router-dom";

/**
 * Tiny one-line legal footer used under BOTH CTAs (free-gate submit + paid-unlock).
 * Renders inline, styled to match the surrounding CTA context (light/dark).
 * Legally, this is a supplementary line — the two explicit checkboxes above the
 * CTA still remain the primary consent signal that we persist server-side.
 */
export function LegalFooter({ variant = "light", testId = "legal-footer" }) {
    const base =
        variant === "dark"
            ? "text-ivory/50 hover:text-ivory/80"
            : "text-charcoal/55 hover:text-charcoal/85";
    const container =
        variant === "dark" ? "text-ivory/45" : "text-charcoal/50";
    return (
        <p
            className={`mt-3 text-center text-[10.5px] leading-relaxed ${container}`}
            data-testid={testId}
        >
            By continuing you agree to our{" "}
            <Link to="/terms" className={`underline underline-offset-2 transition ${base}`} data-testid={`${testId}-terms`}>
                Terms
            </Link>
            {" "}&amp;{" "}
            <Link to="/privacy" className={`underline underline-offset-2 transition ${base}`} data-testid={`${testId}-privacy`}>
                Privacy
            </Link>
            .
        </p>
    );
}
